import {PageTypes} from "../types/page.types";
import {useState} from 'react';
import {shouldShowMoreButton} from "../utils/validation";
export const useInfiniteScroll = () => {
    const [accumulatedRows, setAccumulatedRows] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalSize, setTotalSize] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [maxSize, setMaxSize] = useState(5);

    // 새로운 페이지 데이터 추가
    const appendPageData = (pageData: PageTypes, searchSize: number) => {
        setAccumulatedRows(prev => [...prev, ...pageData.rows]);
        setCurrentPage(pageData.page);
        setTotalSize(pageData.totalSize);
        setPageSize(pageData.pageSize);
        setMaxSize(searchSize);
    };

    // 데이터 초기화 (검색 시)
    const resetPageData = (pageData: PageTypes, searchSize: number) => {
        setAccumulatedRows(pageData.rows);
        setCurrentPage(pageData.page);
        setTotalSize(pageData.totalSize);
        setPageSize(pageData.pageSize);
        setMaxSize(searchSize);
    };

    // 더보기 버튼 표시 여부
    const showMoreButton = shouldShowMoreButton(currentPage, pageSize, totalSize, maxSize);

    // 다음 페이지 번호
    const nextPage = currentPage + 1;

    return {
        accumulatedRows,
        pageSize,
        showMoreButton,
        nextPage,
        appendPageData,
        resetPageData,
    };
};